/**
 * PlatformContext — fetches runtime brand/domain config from GET /api/config.
 *
 * Everything domain- or brand-specific (name, URL, sales email, DNS CNAME target,
 * watermark text) comes from server-side env vars so migrating from
 * preview.emergentagent.com → mediaothers.com is a pure env + DNS change with
 * no code edits required.
 */
import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULTS = {
  platform_name: "MediaOthers",
  platform_url: "https://mediaothers.com",
  platform_domain: "mediaothers.com",
  company_name: "QOthers",
  default_workspace_name: "CasaOthers",
  sales_email: "sales@mediaothers.com",
  support_email: "support@mediaothers.com",
  custom_domain_cname_target: "cname.mediaothers.com",
  watermark_text: "MEDIAOTHERS.COM",
};

const PlatformContext = createContext(DEFAULTS);

export function PlatformProvider({ children }) {
  const [cfg, setCfg] = useState(DEFAULTS);

  useEffect(() => {
    api
      .get("/config")
      .then((r) => setCfg({ ...DEFAULTS, ...r.data }))
      .catch(() => { /* keep defaults on failure */ });
  }, []);

  useEffect(() => {
    // Reflect platform name in browser tab
    if (cfg.platform_name) {
      document.title = `${cfg.platform_name} · Studio`;
    }
  }, [cfg.platform_name]);

  return <PlatformContext.Provider value={cfg}>{children}</PlatformContext.Provider>;
}

export const usePlatform = () => useContext(PlatformContext);
